module.exports = __webpack_public_path__ + "img/img_works02.413277de.jpg";